const getLeadText = ({ components }) => {
    const leadText = components.find((component) => component.subtype === 'lead');

    if (leadText !== undefined) {
        return leadText.text.value;
    }
    return '';
};

export default getLeadText;



/** WEBPACK FOOTER **
 ** ./src/utils/get-lead-text.js
 **/